import { render, staticRenderFns } from "./CollapseItemCard.vue?vue&type=template&id=265b2cfe&scoped=true"
import script from "./CollapseItemCard.vue?vue&type=script&lang=js"
export * from "./CollapseItemCard.vue?vue&type=script&lang=js"
import style0 from "./CollapseItemCard.vue?vue&type=style&index=0&id=265b2cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b2cfe",
  null
  
)

export default component.exports